"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

require("core-js/modules/es6.function.name");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _CategoryNavbarElement = _interopRequireDefault(require("./CategoryNavbarElement"));

var _categoryConfig = _interopRequireDefault(require("../categoryConfig"));

var _Utils = _interopRequireDefault(require("../common/util/Utils"));

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !_construct.default) return false;
    if (_construct.default.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call((0, _construct.default)(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = (0, _construct.default)(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var CategoryNavbarMobile = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(CategoryNavbarMobile, _React$Component);

  var _super = _createSuper2(CategoryNavbarMobile);

  function CategoryNavbarMobile(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CategoryNavbarMobile);
    _this = _super.call(this, props);
    _this.state = {
      hideNav: false,
      isMobile: true
    };
    _this.containerRef = _react.default.createRef();
    _this.onCategoryLinkKeyPressCB = _this.onCategoryLinkKeyPressCB.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(CategoryNavbarMobile, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "hideNav",
    value: function hideNav(isHideNav) {
      this.setState({
        hideNav: isHideNav
      });
    }
  }, {
    key: "getLinkTrackingAttributes",
    value: function getLinkTrackingAttributes(category, index) {
      return {
        role: 'link',
        'data-link-id': category.name,
        'data-link-module': 'global-header',
        'data-link-module-type': 'category-nav',
        'data-link-module-position': 'none',
        'data-link-position': index,
        tabIndex: '0'
      };
    }
  }, {
    key: "onCategoryLinkKeyPressCB",
    value: function onCategoryLinkKeyPressCB(e, catLink) {
      _Utils.default.handleKeyPress(e, function () {
        e.preventDefault();

        if (typeof window !== 'undefined') {
          window.location.href = catLink;
        }
      });
    }
  }, {
    key: "getList",
    value: function getList() {
      var _this2 = this;

      var brandType = this.props.brandType;
      var isMobile = this.state.isMobile;
      return _react.default.createElement("div", {
        className: "uig-mobile-nav-menu-wrapper"
      }, _react.default.createElement("div", {
        className: "uig-mobile-fade-menu-right"
      }), _react.default.createElement("div", {
        className: "uig-mobile-fade-menu-left"
      }), _react.default.createElement("div", {
        className: "uig-mobile-sub-bar-menu-wrap"
      }, _react.default.createElement("div", {
        className: "uig-mobile-sub-bar-menu"
      }, " ", this.props.categories.map(function (category, index) {
        var isActive = category.code === _this2.props.selectedCategoryId;
        return _react.default.createElement(_CategoryNavbarElement.default, {
          key: category.code,
          element: category,
          isMobile: isMobile,
          brandType: brandType,
          className: "uig-mobile-sub-bar-item  ".concat(isActive ? 'active-nav-cat' : '', "  ").concat('brand-' + brandType),
          attr: (0, _objectSpread3.default)({
            role: 'link'
          }, _this2.getLinkTrackingAttributes(category, index)),
          onCategoryLinkKeyPressCB: _this2.onCategoryLinkKeyPressCB
        });
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.categories) return _react.default.createElement("div", null);
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement("nav", {
        "aria-label": "Categories",
        className: "uig-cat-list-mobile-container ".concat(this.state.hideNav ? 'hideNav' : 'showNav', " "),
        ref: this.containerRef
      }, this.getList()));
    }
  }]);
  return CategoryNavbarMobile;
}(_react.default.Component);

exports.default = CategoryNavbarMobile;